import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import AppHeader from "@/components/AppHeader";
import BackButton from "@/components/BackButton";
import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/lib/i18n";
import { Sparkles, MapPin } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PositiveStories() {
  const { t } = useI18n();
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/positive-stories").then((r) => setStories(r.data)); }, []);
  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="stories-page">
      <AppHeader />
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-8">
        <BackButton className="mb-4" testid="stories-back-btn" />
        <div className="mb-10 max-w-2xl">
          <div className="inline-flex items-center gap-2 chip bg-violet-100 text-violet-800"><Sparkles size={12} /> {t("nav_stories")}</div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mt-4">{t("positive_title")}</h1>
          <p className="mt-3 text-slate-600">{t("positive_desc")}</p>
        </div>
        {stories.length === 0 && <div className="text-slate-500">{t("positive_empty")}</div>}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {stories.map((r) => (
            <Link key={r.report_id} to={`/report/${r.report_id}`} data-testid={`story-${r.report_id}`} className="group bg-white border border-slate-200 rounded-2xl overflow-hidden hover-lift">
              {r.photos?.[0] && <img src={`${BACKEND_URL}/api/files/${r.photos[0]}`} alt="story" className="w-full h-56 object-cover" />}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <Badge className="bg-slate-500 text-white">{t("positive_solved")}</Badge>
                  <Badge variant="outline" className="capitalize">{t(`cat_${r.category}`) || r.category}</Badge>
                </div>
                <div className="font-heading font-semibold text-slate-900 line-clamp-2">{r.description}</div>
                <div className="text-xs text-slate-500 mt-2 flex items-center gap-1"><MapPin size={12} /> {r.lat.toFixed(2)}, {r.lng.toFixed(2)}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
